import { render, staticRenderFns } from "./QTextarea.vue?vue&type=template&id=245a8209&"
import script from "./QTextarea.vue?vue&type=script&lang=js&"
export * from "./QTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports